var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinEq23(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 68,
    viewBox: "0 0 54 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1217_5783)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1217_5783)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 67.5C17.9419 59.7919 11.1789 52.6369 6.70645 46.0263C2.23403 39.4156 0 33.3015 0 27.675C0 19.2353 2.71306 12.5158 8.14355 7.50774C13.5697 2.50403 19.8581 0 27 0C34.1419 0 40.4303 2.50403 45.8565 7.50774C51.2826 12.5158 54 19.2353 54 27.675C54 33.3015 51.766 39.4156 47.2935 46.0263C42.8211 52.6369 36.0581 59.7919 27 67.5V67.5Z",
    fill: "#2E197E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 27.675C0.5 19.353 3.16975 12.7748 8.4825 7.87531L8.48252 7.8753C13.8197 2.95359 19.9883 0.5 27 0.5C34.0117 0.5 40.1802 2.95355 45.5173 7.87517C50.826 12.7748 53.5 19.3532 53.5 27.675C53.5 33.1679 51.3183 39.185 46.8794 45.7461C42.4947 52.2272 35.8757 59.2569 27 66.8429C18.1243 59.2569 11.5053 52.2272 7.12058 45.7461C2.68166 39.185 0.5 33.1679 0.5 27.675Z",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.9999 48.87C39.3742 48.87 49.4055 38.8387 49.4055 26.4644C49.4055 14.0901 39.3742 4.05872 26.9999 4.05872C14.6256 4.05872 4.59424 14.0901 4.59424 26.4644C4.59424 38.8387 14.6256 48.87 26.9999 48.87Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 37V35.2632H25.6375V21.2526C25.1392 21.0789 24.6935 20.7943 24.3006 20.3987C23.9077 20.0031 23.625 19.5544 23.4525 19.0526H18.8812L22.475 27.7947C22.4558 28.6632 22.0869 29.4013 21.3681 30.0092C20.6494 30.6171 19.7725 30.9211 18.7375 30.9211C17.7025 30.9211 16.8256 30.6171 16.1069 30.0092C15.3881 29.4013 15.0192 28.6632 15 27.7947L18.5937 19.0526H16.15V17.3158H23.4525C23.6825 16.6404 24.0754 16.0855 24.6312 15.6513C25.1871 15.2171 25.81 15 26.5 15C27.19 15 27.8129 15.2171 28.3687 15.6513C28.9246 16.0855 29.3175 16.6404 29.5475 17.3158H36.85V19.0526H34.4062L38 27.7947C37.9808 28.6632 37.6119 29.4013 36.8931 30.0092C36.1744 30.6171 35.2975 30.9211 34.2625 30.9211C33.2275 30.9211 32.3506 30.6171 31.6319 30.0092C30.9131 29.4013 30.5442 28.6632 30.525 27.7947L34.1187 19.0526H29.5475C29.375 19.5544 29.0923 20.0031 28.6994 20.3987C28.3065 20.7943 27.8608 21.0789 27.3625 21.2526V35.2632H38V37H15ZM32.1062 27.7368H36.4187L34.2625 22.4105L32.1062 27.7368ZM16.5812 27.7368H20.8937L18.7375 22.4105L16.5812 27.7368ZM26.5 19.6316C26.9025 19.6316 27.2427 19.4868 27.5206 19.1974C27.7985 18.9079 27.9375 18.5702 27.9375 18.1842C27.9375 17.7789 27.7985 17.4364 27.5206 17.1566C27.2427 16.8768 26.9025 16.7368 26.5 16.7368C26.1167 16.7368 25.7812 16.8768 25.4937 17.1566C25.2062 17.4364 25.0625 17.7789 25.0625 18.1842C25.0625 18.5702 25.2062 18.9079 25.4937 19.1974C25.7812 19.4868 26.1167 19.6316 26.5 19.6316Z",
    fill: "#516274"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1217_5783",
    x: -4,
    y: 0,
    width: 62,
    height: 75.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1217_5783"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1217_5783",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1217_5783"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 67.5,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinEq23);
export default __webpack_public_path__ + "static/media/pin-eq-23.036a44430d906bbb286fd0a68f898434.svg";
export { ForwardRef as ReactComponent };